/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AuditLogFacetOption,
  AuditLogFacetOption$inboundSchema,
} from "./auditlogfacetoption.js";

export type ListAuditLogFacetsResult = {
  /**
   * Available action facets
   */
  actions: Array<AuditLogFacetOption>;
  /**
   * Available actor facets
   */
  actors: Array<AuditLogFacetOption>;
  /**
   * Available acting surface facets
   */
  surfaces: Array<AuditLogFacetOption>;
};

/** @internal */
export const ListAuditLogFacetsResult$inboundSchema: z.ZodMiniType<
  ListAuditLogFacetsResult,
  unknown
> = z.object({
  actions: z.array(AuditLogFacetOption$inboundSchema),
  actors: z.array(AuditLogFacetOption$inboundSchema),
  surfaces: z.array(AuditLogFacetOption$inboundSchema),
});

export function listAuditLogFacetsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAuditLogFacetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAuditLogFacetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAuditLogFacetsResult' from JSON`,
  );
}
